import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRightIcon } from 'lucide-react';
import { Reveal } from '../Reveal';
export function ContactCta() {
  return <section className="relative overflow-hidden bg-navy py-20 lg:py-24" data-id="element-91" data-mp="1esazqer2mxqd">
      <div className="absolute inset-0" style={{
      background: 'radial-gradient(45% 110% at 22% 0%, rgba(109,40,217,0.45), transparent 70%), radial-gradient(45% 110% at 78% 10%, rgba(13,148,136,0.40), transparent 70%), radial-gradient(50% 120% at 50% 110%, rgba(200,163,73,0.25), transparent 70%)'
    }} aria-hidden="true" data-id="element-92" data-mp="1smttk1sy8sx2" />
      <div className="relative mx-auto flex max-w-5xl flex-col items-center gap-8 px-6 text-center lg:px-10" data-id="element-93" data-mp="2bj3gzfpqqvtq">
        <Reveal data-id="element-94" data-mp="27jb2kmdo1vgg">
          <h2 className="font-display text-3xl font-light leading-tight text-white sm:text-4xl" data-id="element-95" data-mp="27gowysac5q0v">
            Advising boards, CEOs, and investors on what comes next.
          </h2>
        </Reveal>
        <Reveal delay={0.08} data-id="element-96" data-mp="d6v1s13n39iz">
          <p className="max-w-2xl text-base leading-relaxed text-slate-300" data-id="element-97" data-mp="dnln51s5rjc">
            Available for Chief Legal Officer and General Counsel mandates, board and advisory roles, and
            select governance engagements.
          </p>
        </Reveal>
        <Reveal delay={0.14} data-id="element-98" data-mp="aa8slvxd1cpt">
          <Link to="/contact" className="btn-lux group inline-flex items-center gap-2 bg-violet px-9 py-4 text-[0.7rem] font-medium uppercase tracking-micro text-white shadow-jewel transition-colors duration-300 hover:text-navy" data-id="element-99" data-mp="f29zt3fo8d8z">
            Start a conversation
            <ArrowRightIcon className="h-3.5 w-3.5 transition-transform duration-300 group-hover:translate-x-1" data-id="element-100" data-mp="t21l7p8iovx0" />
          </Link>
        </Reveal>
      </div>
    </section>;
}